module.exports = __webpack_public_path__ + "img/room-white.493f7753.svg";